import { useBrokersServiceBrokersTeamsAvailablePermissionsList } from '@insurance/api/queries'
import { usePermissionsCatalog } from '@shared/hooks'
import { ApplicationPermissionsCatalog, AppNames } from '@shared/types'
import { buildPermissionSections } from '@shared/utils'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export const useBrokerPermissionSections = (broker: number) => {
  const { t } = useTranslation()
  const { getCatalogByType, isLoading: isCatalogLoading } =
    usePermissionsCatalog()

  const { data, isLoading } =
    useBrokersServiceBrokersTeamsAvailablePermissionsList({ broker })

  const sections = useMemo(() => {
    const catalog = getCatalogByType(AppNames.Insurance)
    const byValue = new Map(
      (catalog?.permissions ?? []).map((item) => [item.value, item])
    )

    const available: ApplicationPermissionsCatalog = {
      applicationId: catalog?.applicationId ?? 0,
      applicationName: catalog?.applicationName ?? '',
      applicationType: AppNames.Insurance,
      categories: catalog?.categories ?? [],
      permissions: (data ?? []).map(({ permission, label }) => {
        const item = byValue.get(permission)

        return {
          value: permission,
          label: item?.label || label,
          description: item?.description ?? '',
          category: item?.category ?? null
        }
      })
    }

    return buildPermissionSections({
      catalogs: [available],
      otherLabel: t('permissions.category_other'),
      scoped: false
    })
  }, [data, getCatalogByType, t])

  return { sections, isLoading: isLoading || isCatalogLoading }
}
